import { Link, Outlet } from "react-router-dom";

export function Layout() {
  return (
    <>
      <a href="#main" className="skip-link">
        Skip to main content
      </a>
      <header className="app-header">
        <Link to="/" className="brand">
          <img src="/logo.png" alt="" className="brand-logo" />
          <div>
            <h1>Latter Rain TechCare</h1>
            <p className="subtitle">Christian Church of Latter Rain of Philadelphia</p>
          </div>
        </Link>
      </header>
      <main id="main">
        <Outlet />
      </main>
      <footer className="app-footer">
        <p>
          Christian Church of Latter Rain · 525 N 53rd Street, Philadelphia, PA 19131 · 610-609-9049
          <br />
          <a href="https://www.churchoflatterrain.org">www.churchoflatterrain.org</a>
        </p>
        <p className="copyright">
          © {new Date().getFullYear()} All Rights Reserved | Christian Church of Latter Rain
          <br />
          Built by GJ Company LLC
        </p>
      </footer>
    </>
  );
}
